/**
 * Copyright Mántum All Rights Reserved.
 */
import request from '.';
import type { Method, Headers, Result } from '../type';

type Options = {
    body?: BodyInit | Record<string, unknown>;
    method: Method;
    headers?: Headers;
    result?: Result;
    signal?: AbortSignal;
};

export default function fetch<T>(url: string, options: Options) {
    let parameter: Record<string, string> = {};

    if (options.method === 'GET' && options.body) {
        parameter = options.body as Record<string, string>;
        options.body = undefined;
    }

    return request<T>(url, {
        body: options.body,
        headers: options.headers,
        method: options.method,
        parameter: parameter,
        result: options.result,
        signal: options.signal
    });
}
